// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-dialog__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.confirm-dialog {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.confirm-dialog__title {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.confirm-dialog__message {
  margin: 0 0 24px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.confirm-dialog__actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.confirm-dialog__button {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.confirm-dialog__button:active {
  transform: scale(0.98);
}

.confirm-dialog__button--cancel {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  color: #666;
}

.confirm-dialog__button--cancel:hover {
  background: #ebebeb;
}

.confirm-dialog__button--confirm {
  background: #2563eb;
  border: none;
  color: white;
}

.confirm-dialog__button--confirm:hover {
  background: #1d4ed8;
}

.confirm-dialog__button--destructive {
  background: #dc2626;
}

.confirm-dialog__button--destructive:hover {
  background: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ConfirmDialog/ConfirmDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".confirm-dialog__overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.confirm-dialog {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.confirm-dialog__title {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.confirm-dialog__message {\n  margin: 0 0 24px 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.5;\n}\n\n.confirm-dialog__actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.confirm-dialog__button {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.1s;\n}\n\n.confirm-dialog__button:active {\n  transform: scale(0.98);\n}\n\n.confirm-dialog__button--cancel {\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  color: #666;\n}\n\n.confirm-dialog__button--cancel:hover {\n  background: #ebebeb;\n}\n\n.confirm-dialog__button--confirm {\n  background: #2563eb;\n  border: none;\n  color: white;\n}\n\n.confirm-dialog__button--confirm:hover {\n  background: #1d4ed8;\n}\n\n.confirm-dialog__button--destructive {\n  background: #dc2626;\n}\n\n.confirm-dialog__button--destructive:hover {\n  background: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
